export default __webpack_public_path__ + "static/madden-b2bfeefe73e364435817635976cd7dc9.png";